import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getPublicUpcomingPicks } from "@/lib/publicPicks.functions";
import { hubJsonLd } from "@/lib/picksJsonLd";
import { ServerPicksList } from "@/components/predictions/ServerPicksList";

const picksQuery = queryOptions({ queryKey: ["public-upcoming-picks"], queryFn: () => getPublicUpcomingPicks(), staleTime: 5 * 60_000 });
const safeOnly = <T extends { confidence_score: number | null }>(rows: T[]) => rows.filter((p) => (p.confidence_score ?? 0) >= 70);
import SafeBetPortal from "@/pages/SafeBetPortal";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/safe-bets")({
  loader: ({ context }) => context.queryClient.ensureQueryData(picksQuery),
  head: ({ loaderData }) => ({
    meta: [
      { title: "Safe Bets Today: High-Confidence Football Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["safeBets"] }).meta },
      { name: "description", content: "Low-risk, high-confidence football tips generated on demand. Our strongest strategies, our most-cautious calls — nothing padded, nothing spun." },
      { property: "og:title", content: "Safe Bets Today: High-Confidence Football Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Low-risk, high-confidence football tips generated on demand. Our strongest strategies, our most-cautious calls — nothing padded, nothing spun." },
      { name: "twitter:title", content: "Safe Bets Today: High-Confidence Football Tips | Statlign" },
      { name: "twitter:description", content: "Low-risk, high-confidence football tips generated on demand. Our strongest strategies, our most-cautious calls — nothing padded, nothing spun." },
    ],
    scripts: hubJsonLd({ path: "/safe-bets", name: "Safe bets today", description: "High-confidence football tips with odds and reasoning.", picks: safeOnly(loaderData ?? []) }),
  }),
  component: SafeBetsRoute,
});

function SafeBetsRoute() {
  const { data } = useSuspenseQuery(picksQuery);
  return (
    <MainLayout>
      <SafeBetPortal />
      <ServerPicksList picks={safeOnly(data).slice(0, 20)} />
    </MainLayout>
  );
}
